import { Collapse } from 'antd';
import SolicitudesTable from 'components/tables/SolicitudesTable';
import SolicitudesForDayTable from 'components/tables/SolicitudesForDayTable';
import { useCalendarActions } from 'providers/CalendarSolc/CalendarActionsProvider';
import { useSolicitudes } from 'providers/SolicitudesProvider';
import { SOLICITUD_TIPOS } from 'assets/data/SolicitudesEstados';

const CalendarSidePanel = () => {
  const { selectedDay } = useCalendarActions();
  const { data, selectedData } = useSolicitudes();

  const pendingCount = (data || []).filter((s) => s.status === SOLICITUD_TIPOS.SIN_ASIGNAR).length;
  const dayCount = selectedData?.length || 0;
  const dayLabel = selectedDay?.format('ddd D MMM') || '—';

  return (
    <div className="space-y-3">
      <Collapse
        defaultActiveKey={['pendientes']}
        items={[
          {
            key: 'pendientes',
            label: (
              <div className="flex items-center gap-2">
                <span className="font-medium text-sm">Pendientes globales</span>
                <span className="text-[11px] bg-orange-100 text-orange-700 px-2 py-0.5 rounded-full font-medium">
                  {pendingCount}
                </span>
              </div>
            ),
            children: <SolicitudesTable />,
          },
        ]}
      />

      <Collapse
        defaultActiveKey={['dia']}
        items={[
          {
            key: 'dia',
            label: (
              <div className="flex items-center gap-2">
                <span className="font-medium text-sm text-blue-900">Detalle — {dayLabel}</span>
                <span className="text-[11px] bg-blue-200 text-blue-800 px-2 py-0.5 rounded-full font-medium">
                  {dayCount}
                </span>
              </div>
            ),
            children: <SolicitudesForDayTable />,
          },
        ]}
      />
    </div>
  );
};

export default CalendarSidePanel;
